import { IUpdateCompanyPasswordParam, IUpdateCompanyPhoneParam } from '../../types/app-account/enterprise';
import { EAxiosResponseCode, getHttpErrorMessage, Http } from '@core/api';
import { getHostbaseUrl } from '@core/tools';

const hostUrl = getHostbaseUrl();

/**
 * 账户中心 - 企业安全 - 修改密码
 */
export async function updateEnterprisePassword(params: IUpdateCompanyPasswordParam) {
  try {
    const { code, message } = await Http.post<void>(`${hostUrl}/side/companyPay/updatePassword`, params);

    if (code !== EAxiosResponseCode.Succeed) {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }
}

/**
 * 账户中心 - 企业安全  - 修改手机号
 */
export async function updateEnterprisePhone(params: IUpdateCompanyPhoneParam) {
  try {
    const { code, message } = await Http.post<void>(`${hostUrl}/side/companyPay/updatePhone`, params);

    if (code !== EAxiosResponseCode.Succeed) {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }
}
